export class Email {
    subject: string;
    body: string;
}
